// @ts-nocheck
<script setup lang="ts">
import OrthoPlanForm from "@/components/models/patient/forms/OrthoProposedPlanAddEditForm.vue";
import { useOrthoProposedPlan } from "@/composables/models/patient/useOrthoPlan";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { definePage } from "unplugin-vue-router/runtime";
import QuestionnaireLayout from "@/components/models/patient/questionnaire/QuestionnaireLayout.vue";
import QuestionnaireSideBar from "@/components/models/patient/questionnaire/QuestionnaireSideBar.vue";
import { useAbility } from "@casl/vue";
import { usePatient } from "@/composables/models/patient/usePatient";
import { getActualTreatmentPlan } from "@/api/models/patient/patient";
import { useOrthoNeeds } from "@/composables/models/patient/useOrthoNeeds";
import { useCachedPatientFiles } from "@/composables/models/patient/usePatientFiles";

definePage({
  meta: {
    title: "generic.action.viewEntity",
    titleParams: { entity: "generic.entity.orthoProposedPlan" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.READ, $permSubjects.PATIENT__ORTHOPROPOSEDPLAN);
    },
  },
});

const route = useRoute();
const { t } = useI18n();

const orthoProposedPlanId = (route.params as { id: string }).id;
const { data: orthoProposedPlan, isLoading: isOrthoProposedPlanLoading } = useOrthoProposedPlan(
  {
    id: orthoProposedPlanId,
  },
  { redirectOnNotFound: true }
);
const patientId = computed(() => orthoProposedPlan.value?.patient);

const { data: patient, isLoading: isPatientLoading } = usePatient(
  { id: patientId },
  { redirectOnNotFound: true }
);
const orthoNeeds = computed(() => getActualTreatmentPlan(patient.value)?.ortho_needs?.at(-1));
const { data: orthoNeedsData, isLoading: isOrthoNeedsLoading } = useOrthoNeeds(
  {
    id: orthoNeeds,
  },
  { redirectOnNotFound: true }
);
const { patientFiles, isLoading: isPatientFilesLoading } = useCachedPatientFiles({
  patientId: computed(() => patientId.value as string | undefined),
});
</script>
<template>
  <v-skeleton-loader
    :loading="isOrthoProposedPlanLoading || isPatientLoading || isOrthoNeedsLoading"
  >
    <questionnaire-layout
      :title="t('models.patient.orthoProposedPlan.title')"
      show-compact-summary
      readonly
    >
      <ortho-plan-form
        :patient="patient"
        :disabled="true"
        :readonly="true"
        :default-values="orthoProposedPlan"
        :ortho-needs-data="orthoNeedsData"
      />

      <template #sidebar>
        <questionnaire-side-bar
          :patient="patient"
          :patient-files="patientFiles"
          :is-loading="isPatientFilesLoading"
        />
      </template>
    </questionnaire-layout>
  </v-skeleton-loader>
</template>
